var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGroups = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 49 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19624"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19616"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19467",
  transform: "translate(-.499 .067)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 24.5,
  cy: 25,
  fill: "none",
  "data-name": "Ellipse 1393",
  rx: 24.5,
  ry: 25,
  transform: "translate(.499 -.068)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  "data-name": "Group 19468"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M15.443 22.504a9.41 9.41 0 0 1 6.446-6.529",
  "data-name": "Path 27312"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M21.889 34.024a9.41 9.41 0 0 1-6.446-6.529",
  "data-name": "Path 27313"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M33.557 27.495a9.41 9.41 0 0 1-6.446 6.529",
  "data-name": "Path 27314"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M27.112 15.975a9.41 9.41 0 0 1 6.272 5.968",
  "data-name": "Path 27315"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.087 16.059a2.588 2.588 0 1 1-2.587-2.587 2.587 2.587 0 0 1 2.587 2.587Z",
  "data-name": "Path 27316"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.087 33.939a2.588 2.588 0 1 1-2.587-2.587 2.587 2.587 0 0 1 2.587 2.587Z",
  "data-name": "Path 27317"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.107 27.587A2.588 2.588 0 1 1 17.694 25a2.587 2.587 0 0 1-2.587 2.587",
  "data-name": "Path 27318"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.48 24.999a2.588 2.588 0 1 1-2.587-2.587 2.587 2.587 0 0 1 2.587 2.587Z",
  "data-name": "Path 27319"
}))))));
export { SvgGroups as ReactComponent };
export default __webpack_public_path__ + "static/media/groups.aeed777cab8fbd0f9b37aede0aa3988a.svg";